import { useAuthStore } from '@/store/useAuthStore';
import { usePermissions } from '@/lib/permissionsStore';
import type { Access } from '@/lib/appShell/navModel';

/** Who is looking, in the shape navModel's guard rule wants. */
export function useNavAccess(): Access {
  const role = useAuthStore((s) => s.profile?.role ?? null);
  const { can } = usePermissions();
  return { role, can };
}
